import { Grid } from "@mui/material";
import FormDatePicker from "components/FormFields/FormDatePicker";
import dayjs from "dayjs";
import { subtractFromDate } from "utils/date";

const dateStyle = {
  ".MuiInputBase-root": {
    background: "transparent",
    marginRight: "10px",
    disableUnderline: true,
    maxWidth: "160px",
  },
  ".MuiFormLabel-root": {
    color: "#94BA33",
  },
  ".MuiInputBase-input": {
    color: "#94BA33",
    fontSize: "0.875rem",
    fontWeight: 500,
    padding: "4px 8px",
    backgroundColor: "transparent",
    height: "30px !important",
  },
  "&:focus": {
    background: "transparent !important",
  },
  ".MuiSvgIcon-root": {
    color: "#94BA33",
  },
};

const DateRangeFilter = ({
  startDate,
  endDate,
  handleStartDateChange,
  handleEndDateChange,
}) => {
  return (
    <>
      <Grid item>
        <FormDatePicker
          name="start_date"
          required
          label="Start Date"
          value={dayjs(startDate)}
          onChange={handleStartDateChange}
          variant="standard"
          maxDate={dayjs(new Date())}
          minDate={dayjs(subtractFromDate(new Date(), 180).toDate())}
          sx={dateStyle}
          manuallyEditable={false}
        />
      </Grid>

      <Grid item>
        <FormDatePicker
          name="end_date"
          label="End Date"
          required
          value={dayjs(endDate)}
          onChange={handleEndDateChange}
          variant="standard"
          maxDate={dayjs(new Date())}
          minDate={dayjs(subtractFromDate(new Date(), 180).toDate())}
          sx={dateStyle}
          manuallyEditable={false}
        />
      </Grid>
    </>
  );
};

export default DateRangeFilter;
